"use client";

import { useUser } from "@/context/user-context";
import { EfnAuth } from "@/services/auth/types";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

const getInitials = (email: string, firstName?: string, lastName?: string) => {
  if (firstName && lastName) {
    return (firstName[0] + lastName[0]).toUpperCase();
  }

  if (firstName) {
    return firstName.slice(0, 2).toUpperCase();
  }

  if (lastName) {
    return lastName.slice(0, 2).toUpperCase();
  }

  if (email) {
    const match = email.match(/^[a-zA-Z0-9]+/);
    return match ? match[0].slice(0, 2).toUpperCase() : "";
  }

  return "";
};

const MENU_ITEMS = [
  {
    label: "Mitt flöde",
    url: "/konto/mitt-efn",
  },
  {
    label: "Sparade artiklar",
    url: "/konto/sparade-artiklar",
  },
  {
    label: "Ämnen",
    url: "/konto/amnen",
  },
  {
    label: "E-tidning",
    url: "/e-tidning",
  },
  {
    label: "Prenumerationer",
    url: "/konto/prenumerationer",
  },
  {
    label: "Personuppgifter",
    url: "/konto",
  },
];

type AccountButtonProps = {
  user: EfnAuth.UserCookie;
};

const AccountButton = (props: AccountButtonProps) => {
  const pathname = usePathname();
  const [isOpen, setIsOpen] = useState(false);
  const { logout } = useUser();

  useEffect(() => {
    setIsOpen(false);
  }, [pathname]);

  const initials = getInitials(
    props.user?.info.email!,
    props.user?.info.firstname!,
    props.user?.info.lastname!,
  );

  return (
    <div className="relative">
      <button
        aria-label="Kontomeny"
        aria-expanded={isOpen}
        onClick={() => setIsOpen(!isOpen)}
        className="btn-icon btn-default text-sm"
      >
        {initials}
      </button>

      {isOpen && (
        <div className="absolute z-40 right-0 mt-2.5 shadow-sm rounded-sm overflow-hidden w-[180px]">
          {MENU_ITEMS.map((menuItem, index) => (
            <Link
              key={`account-button-menu-item-${index}`}
              className="block p-4 bg-white-500 hover:bg-sand-800 hover:opacity-100 font-bold border-b border-sand-600"
              href={menuItem.url}
            >
              {menuItem.label}
            </Link>
          ))}
          <a
            href="/logga-ut"
            className="block p-4 bg-white-500 hover:bg-sand-800  hover:opacity-100 font-bold border-b border-sand-600"
          >
            Logga ut
          </a>
        </div>
      )}
    </div>
  );
};

export default AccountButton;
